const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/notificationList.ts';
import { MessageDescriptor } from 'react-intl';

const ACTION_TYPE_ADD_TO_NOTIFICATION_LIST = 'PATAPP_ADD_TO_NOTIFICATIONLIST';

export function addToNotificationListRecords(notificationListObj: {
    text: MessageDescriptor;
    actionText: MessageDescriptor;
    routeTo: string;
}) {
    return {
        type: ACTION_TYPE_ADD_TO_NOTIFICATION_LIST,
        notificationListObj,
    };
}
